import { z } from 'zod';

import { schemaBigDecimal } from '../../../../utils/schema.utils';
import { schemaEuropaceAntragstellerzuordnung } from '../../Antragstellerzuordnung.schema';

/*
	https://docs.api.europace.de/privatkredit/vorgaenge/kex-vorgang-import-api/#sonstiger-verm%C3%B6genswert

	{
		"betrag": schemaBigDecimal,
		"gehoertZuAntragsteller": Antragstellerzuordnung
	}

*/

export const schemaEuropaceSonstigerVermoegenswert = z.object({
    betrag: z.optional(schemaBigDecimal),
    europaceId: z.optional(z.string().min(1)),
    gehoertZuAntragsteller: z.optional(schemaEuropaceAntragstellerzuordnung),
    id: z.string().min(1),
});

export type SchemaEuropaceSonstigerVermoegenswert = z.infer<typeof schemaEuropaceSonstigerVermoegenswert>;
